import styles from './ListTable.module.scss';

type Props = {
    children: React.ReactNode;
    name?: string;
    style?: React.CSSProperties;
};

const LTMobileItem = ({ children, name, style }: Props) => {
    return (
        <section className={styles.itemM}>
            {name && (
                <h5 style={style} className={styles.titleM}>
                    {name}
                </h5>
            )}
            {children}
        </section>
    );
};

export { LTMobileItem };
